const cityCharReplacements: Record<string, string> = {
    "à": "a'",
    "è": "e'",
    "é": "e'",
    "ì": "i'",
    "ò": "o'",
    "ù": "u'",
};

export function normalizeCityString(str: string): string {
    return str
        .split("")
        .map(char => cityCharReplacements[char] ?? char)
        .join("");
}